export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/javascript.0bfc8be.svg";